import { render, staticRenderFns } from "./ModbusConverter.vue?vue&type=template&id=bfecf33c&lang=pug&"
import script from "./ModbusConverter.vue?vue&type=script&lang=ts&"
export * from "./ModbusConverter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports